import { useLocation } from "react-router-dom";
import { Construction } from "lucide-react";
import { EmptyState } from "../../components/shared/EmptyState";
import { ADMIN_NAV } from "../../components/layout/AdminLayout";

const MODULE_NOTES = {
  "/admin/clients": "B11 — CRM : événements, réservations, tags, notes internes, remises manuelles, détection de doublons sans fusion automatique.",
  "/admin/rendez-vous": "B13 — Agenda exclusivement Art Event : découverte, coordination, location, dépôt, téléphone/visio, partenaire.",
  "/admin/devis": "B14 — Devis versionnés (jamais écrasés), devis accepté ≠ réservation confirmée, transformation avec nouveau contrôle de disponibilité.",
  "/admin/documents": "B16 — CGV versionnées et immuables après acceptation, preuves d'acceptation, documents contractuels non supprimables.",
  "/admin/codes-promo": "B17 — Codes promo + remises manuelles séparées, aucune remise sur la caution, cumul non par défaut.",
  "/admin/retours": "B09 — Contrôle par quantité, retours partiels, photos, nettoyage en masse, incident documenté.",
  "/admin/cautions": "B10 — Cautions séparées du CA, aucune retenue automatique, décision humaine obligatoire.",
  "/admin/alertes": "Alertes de disponibilité — conflits, ruptures prévisionnelles, retours en retard.",
  "/admin/realisations": "B18 — Publication volontaire uniquement, photos via la Médiathèque centrale, SEO/alt, produits utilisés.",
  "/admin/blog": "B20 — Articles administrables, programmation, SEO, liens produits/formules/réalisations.",
  "/admin/pages": "Gestion des contenus éditoriaux des pages publiques A01-A25.",
  "/admin/mediatheque": "Médiathèque centrale (11 bis) : import multiple, optimisation web, ALT, suivi des usages, protection contre les suppressions.",
  "/admin/partenaires": "B19 — Annuaire publié uniquement sur décision d'Art Event.",
  "/admin/reglages": "B21 — Tous les réglages commerciaux centralisés (acompte, solde, livraison, caution par défaut, horaires…) — jamais codés en dur.",
  "/admin/utilisateurs": "B22 — Rôles (Administrateur principal, Collaborateur, Planning & Logistique), permissions Aucun/Lecture/Modifier/Complet, droits financiers séparés.",
  "/admin/parametres": "B23 — État des services, sauvegardes, journal système. Aucun fournisseur n'est présenté comme actif tant qu'il n'est pas choisi.",
};

export default function AdminPlaceholder() {
  const { pathname } = useLocation();
  const module = ADMIN_NAV.flatMap((g) => g.items).find((i) => i.to === pathname);
  return (
    <div data-testid={`admin-placeholder-${pathname.replace(/\//g, "-")}`}>
      {module && <p className="overline-ae">{module.ref} — {module.label}</p>}
      <h1 className="mt-1 font-heading text-2xl sm:text-3xl text-deepgreen">{module?.label || "Module"}</h1>
      <div className="mt-6">
        <EmptyState icon={Construction} title="Module en préparation">
          {MODULE_NOTES[pathname] || "Ce module sera ouvert prochainement, selon les priorités d'Art Event."}
        </EmptyState>
      </div>
    </div>
  );
}
